import { useDispatch } from "react-redux";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import {
  openCredentialDialog,
  setCredentialDialogMode
} from "redux/actions/portal/credentialManagementActionCreator";
import ProtectedButton from "authentication/ProtectedButton";
import { Icon } from "@mui/material";
import { ThemedReloadIcon } from "assets/CXFIcons/Static";
import { PERMISSIONS } from "constants/portal";
import { useCredentials } from "../../../../../hooks/useCredentials";

const CredentialManagementFilter = () => {
  const dispatch = useDispatch();
  const { handleFetchCredentials } = useCredentials();

  return (
    <SoftBox
      display={{
        xs: "grid",
        lg: "flex"
      }}
      justifyContent={{ lg: "flex-end" }}
      width="100%"
      gap={1}
      sx={{
        gridTemplateColumns: {
          md: "repeat(2, 1fr)"
        }
      }}
    >
      <SoftButton variant="gradient" size="medium" color="primary" onClick={handleFetchCredentials}>
        <ThemedReloadIcon color="white" height="20px" />
      </SoftButton>
      <ProtectedButton permissionName={PERMISSIONS.CREATE_CREDENTIALS}>
        <SoftButton
          variant="gradient"
          color="primary"
          size="medium"
          onClick={() => {
            dispatch(setCredentialDialogMode("add"));
            dispatch(openCredentialDialog());
          }}
          sx={{
            minWidth: "180px",
            maxWidth: { xl: "250px" },
            width: { xs: "100%", xl: "100%" }
          }}
        >
          <Icon>add</Icon>&nbsp;Add
        </SoftButton>
      </ProtectedButton>
    </SoftBox>
  );
};

export default CredentialManagementFilter;
